module.exports = __webpack_public_path__ + "static/media/loadingFailed.1857099b.jpg";